import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="#18A0A0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M22 6l-10 7L2 6" stroke="#18A0A0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);